import { APPROVED_FILE_TYPES } from '../constants/approvedFileTypes'
import { FILE_EXTENSION_REGEX } from '../constants/regex'

export function getArticle(word: string): string {
  const vowels = ['a', 'e', 'i', 'o', 'u']
  if (vowels.includes(word.toLowerCase().charAt(0)) && !word.startsWith('URL')) {
    return 'an'
  }
  return 'a'
}

export function getHostFromUrl(url: string): string | null {
  return url.match(/https?:\/\/.+?(?=\/)/)?.[0] ?? null
}

export const getExtensionFromFileName = (name: string): string =>
  name.match(FILE_EXTENSION_REGEX)?.[0] || ''

// TODO - look into checking type via file reader - DF
export const isValidFileExtension = (file: File): boolean => {
  const extension = getExtensionFromFileName(file.name).toLowerCase().replace('.', '') || ''
  return APPROVED_FILE_TYPES.has(extension)
}
